import React, { useState, useEffect } from 'react'
import styles from './header.module.scss'
import { ReactComponent as Logo } from '../../../assets/images/logo.svg'

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isMenuOpen])

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const closeMenu = () => {
    setIsMenuOpen(false)
  }

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      })
    }
    closeMenu()
  }

  return (
    <div className={styles.header}>
      <div className={styles.leftSide}>
        <Logo />
        <h2>Dental Med</h2>
      </div>
      
      {/* Desktop Navigation */}
      <div className={styles.rightSide}>
        <ul>
          <li onClick={() => scrollToSection('firstSection')}>Ballina</li>
          <li onClick={() => scrollToSection('secondSection')}>Rreth nesh</li>
          <li onClick={() => scrollToSection('thirdSection')}>Shërbimet</li>
          <li onClick={() => scrollToSection('teamSection')}>Ekipi</li>
          <li onClick={() => scrollToSection('footer')}>Informacioni</li>
        </ul>
      </div>

      {/* Mobile Hamburger Menu */}
      <div className={styles.mobileMenu}>
        <button 
          className={`${styles.hamburger} ${isMenuOpen ? styles.active : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        
        <div className={`${styles.mobileNav} ${isMenuOpen ? styles.open : ''}`}>
          <ul>
            <li onClick={() => scrollToSection('firstSection')}>Ballina</li>
            <li onClick={() => scrollToSection('secondSection')}>Rreth nesh</li>
            <li onClick={() => scrollToSection('thirdSection')}>Shërbimet</li>
            <li onClick={() => scrollToSection('teamSection')}>Ekipi</li>
            <li onClick={() => scrollToSection('footer')}>Informacioni</li>
          </ul>
        </div>
      </div>
    </div>
  )
}
